<script>
		import { createEventDispatcher } from 'svelte';
    import MdcUtils from './MdcUtils';

const dispatch = createEventDispatcher();
export let account;
let amt = 0, desc=''
let errors = {}

$: amt = Math.floor(amt)

$: if(amt > account.avail) {
	errors.amtErr = 'Amount exceeds available balance'
} else {
	deleteError('amtErr')
}

$: if(amt <1) {
	errors.negative='Enter an amount'
} else {
	deleteError('negative')
}

$: if(!desc.length) {
	errors.descErr = 'A description is required'
} else {
	deleteError('descErr')
}

function deleteError(key) {
	delete errors[key]
	errors = errors
}

function leaveThatCash() {
	document.querySelector('#leaveCash').classList.toggle('disabled')
		dispatch('action',{do:'doLeaveCashFinalize', acct: account.id, amt, desc} )
}

</script>

<div class="modal panel" id="leaveCash">
<h2>Leave Cash</h2>
<!--Input for amount, which must be less than account balance-->
<div class="leave-cash-input">
	<p>Available: {MdcUtils.format(account.avail)}</p> 
	<p>
	<label for="leave-cash-amount">Amount</label>
	<input type="number" id="leave-cash-amount" name="leave-cash-amount" min="0" max={account.avail} bind:value={amt} 
	on:focus={ ()=>{if(amt==0)amt=''}}>
</p>
	<!-- input for description with a limit of 64 chars-->
	<p>
	<label for="leave-cash-description">Description</label>
	<input type="text" id="leave-cash-description" name="leave-cash-description" maxlength="64" bind:value={desc} >
</p>
</div>

<!-- if account.msgs, display the messages, one per line, in red font-->
{#if errors}
	<div class="leave-cash-msgs">
		{#each Object.values(errors) as error}
			<div class="leave-cash-msg red">
				{error}
			</div>
		{/each}
	</div>
{/if}

<!--Button to leave cash--> 
<div class="leave-cash-actions mt-3">
	<button  on:click={() => dispatch('action',{do:'doSelectAccount', account})}>Cancel</button>
	<button  disabled={Object.keys(errors).length} on:click={ leaveThatCash }>Leave Cash</button>
</div>

</div>

<style>
	
</style>